import React from 'react';
import { ArrowRight } from 'lucide-react';
import PageLayout from '../components/PageLayout';

const PrivacyPolicyPage = () => {
  return (
    <PageLayout title="Privacy Policy">
      <div className="space-y-8 text-slate-600">
        <div>
          <p className="font-semibold text-slate-900">SignalPath Digital Health Applications, LLC.</p>
          <p className="text-sm text-slate-500">Last Updated: January 01, 2026</p>
        </div>
        
        <p>
          Welcome to SignalPath Digital Health Applications, LLC.
        </p>
        
        <p>
          Please select the SignalPath app below to look at the entity's specific Privacy Policy:
        </p>

        <div className="mt-8">
          <a 
            href="https://a1csurvivalplan.com" 
            target="_blank" 
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-teal-500 hover:bg-teal-600 text-white font-semibold px-6 py-3 rounded-lg transition-colors"
          >
            A1C Survival Plan Privacy Policy
            <ArrowRight className="h-4 w-4" />
          </a>
        </div>
      </div>
    </PageLayout>
  );
};

export default PrivacyPolicyPage;
